<template>
  <el-container class="container" direction="vertical" @keyup.enter.native="login()">
    <el-row class="login_panel">
      <el-card>
        <div slot="header" class="panel_title">登录</div>
        <el-form ref="loginVO" :model="loginVO" :rules="$rules.login_rules" size="small">
          <el-form-item prop="username">
            <el-input v-model.trim="loginVO.username" placeholder="请输入账号">
              <template slot="prepend">
                <i class="el-icon-user"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input show-password v-model.trim="loginVO.password" placeholder="请输入密码">
              <template slot="prepend">
                <i class="el-icon-lock"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="verifyCode">
            <el-row :gutter="30">
              <el-col :span="16">
                <el-input
                  class="verify_input"
                  v-model.trim="loginVO.verifyCode"
                  placeholder="请输入验证码"
                  size="small"
                  maxlength="4"
                  minlength="4"
                >
                  <template slot="prepend">
                    <i class="el-icon-postcard"></i>
                  </template>
                </el-input>
              </el-col>
              <el-col :span="8">
                <img :src="verifyImgUrl" @click="refreshVerifyImage()" alt="验证码" class="verify_img" />
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
        <el-row>
          <!-- <el-col :span="24">
            <el-link type="info" class="lost_password">忘记密码？</el-link>
          </el-col> -->
          <el-col :span="24">
            <el-button type="primary" @click="login()" native-type="submit" class="login_btn">
              登录
            </el-button>
          </el-col>
        </el-row>
      </el-card>
    </el-row>
  </el-container>
</template>
<script>
import { LoginVO } from "@/libs/model";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      verifyImgUrl: "",
      loginVO: new LoginVO()
    };
  },
  methods: {
    ...mapActions(["initCurrentUserInfo"]),
    refreshVerifyImage() {
      this.verifyImgUrl = `${this.$http.instance.defaults.baseURL}${this.$http.verifyImage()}?r=${Math.random()}`;
    },
    checkLoginForm(fun) {
      this.$refs["loginVO"].validate(valid => {
        if (valid) {
          fun(valid);
        }
      });
    },
    login() {
      this.checkLoginForm(() => {
        this.$http.login(this.loginVO).then(response => {
          this.refreshVerifyImage();
          var res = this.$http.data(response);
          if (this.$http.success(res)) {
            this.$message({
              showClose: true,
              message: "登录成功",
              type: "success"
            });
            this.initCurrentUserInfo().then(() => {
              this.$router.push({
                path: "/management"
              });
            });
          } else {
            this.$message.error(res.msg);
            this.loginVO.verifyCode = "";
          }
        });
      });
    }
  },
  mounted() {
    this.refreshVerifyImage();
  }
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  top: 0;
  width: 100%;
  height: calc(100vh - 4rem);
}
.login_panel {
  position: absolute;
  top: 45%;
  left: 50%;
  width: 23.25rem;
  transform: translate(-50%, -50%);

  .panel_title {
    text-align: center;
    font-weight: bold;
    font-size: 1.13rem;
  }

  .el-form-item--small.el-form-item {
    margin-bottom: 2rem;
  }

  .verify_input {
    width: 12.5rem;
  }

  .verify_img {
    height: 2rem;
    float: right;
    cursor: pointer;
    margin-top: -1px;
    margin-left: 2rem;
  }

  .verify_slur {
    margin-left: 1rem;
    user-select: none;
  }

  .lost_password {
    margin-top: -0.375rem;
    margin-bottom: 1.25rem;
    float: left;
    cursor: pointer;
    user-select: none;
  }

  .login_btn {
    width: 100%;
    margin-bottom: 0.625rem;
  }

  /** 去除卡片圆角 */
  .el-card {
    border-radius: 0;
  }
}
</style>
